const KeenSlider = window.KeenSlider

const { useAutoplay, useArrows, useInitialised } = window.BAO.Carousel.plugins

class AnnouncementBar extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.slideSpeed = this.dataset.slideSpeed

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        useAutoplay(this.slideSpeed, { pauseOnHover: false }),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useInitialised(),
      ],
    )
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
